export const TAM_HOP = [
  ['Than','Ty','Thin'],
  ['Hoi','Mao','Mui'],
  ['Dan','Ngo','Tuat'],
  ['Ty_','Dau','Suu']
];

export const LUC_HOP = {
  Ty: 'Suu',
  Dan: 'Hoi',
  Mao: 'Tuat',
  Thin: 'Dau',
  Ty_: 'Than',
  Ngo: 'Mui'
};

export const TU_XUNG = [
  ['Ty','Ngo'],
  ['Suu','Mui'],
  ['Dan','Than'],
  ['Mao','Dau'],
  ['Thin','Tuat'],
  ['Ty_','Hoi']
];

export const TU_HINH = [
  ['Dan', 'Ty_', 'Than'],
  ['Suu', 'Mui', 'Tuat'],
  ['Ty', 'Mao'],
  ['Thin', 'Thin'],
  ['Ngo', 'Ngo'],
  ['Dau', 'Dau'],
  ['Hoi', 'Hoi']
];

const SELF_HINH = new Set(['Thin', 'Ngo', 'Dau', 'Hoi']);
const PAIR_HINH = TU_HINH.filter((group) => group.length === 2);
const TAM_HINH = TU_HINH.filter((group) => group.length === 3);

export const TU_HAI = [
  ['Ty', 'Mui'],
  ['Suu', 'Ngo'],
  ['Dan', 'Ty_'],
  ['Mao', 'Thin'],
  ['Than', 'Hoi'],
  ['Dau', 'Tuat']
];

export const TU_PHA = [
  ['Ty', 'Mao'],
  ['Suu', 'Thin'],
  ['Dan', 'Ty_'],
  ['Mao', 'Ngo'],
  ['Thin', 'Mui'],
  ['Ty_', 'Than'],
  ['Ngo', 'Dau'],
  ['Mui', 'Tuat'],
  ['Than', 'Hoi'],
  ['Dau', 'Ty'],
  ['Tuat', 'Suu'],
  ['Hoi', 'Dan']
];

export const AM_HOP = {
  'Ty-Thin': 'Thuy',
  'Suu-Ngo': 'Tho',
  'Dan-Hoi': 'Moc',
  'Mao-Tuat': 'Hoa',
  'Ty_-Than': 'Kim',
  'Dau-Ty': 'Kim'
};

export const VIEN_PHUONG_HOI = {
  'Dan-Mao-Thin': 'Moc',
  'Ty_-Ngo-Mui': 'Hoa',
  'Than-Dau-Tuat': 'Kim',
  'Hoi-Ty-Suu': 'Thuy'
};

const isPairMatch = (pair, a, b) => (
  (pair[0] === a && pair[1] === b) || (pair[0] === b && pair[1] === a)
);

export function checkTuXung(a, b) {
  if (a === b) return false;
  return TU_XUNG.some((pair) => isPairMatch(pair, a, b));
}

export function checkLucHop(a, b) {
  return LUC_HOP[a] === b || LUC_HOP[b] === a;
}

export function checkTamHop(...branches) {
  return TAM_HOP.some(group => branches.every(branch => group.includes(branch)));
}

export function findTamHopGroups(branches = []) {
  return TAM_HOP.filter((group) => group.every((branch) => branches.includes(branch)));
}

export function checkTuHinh(a, b) {
  if (a === b) {
    return SELF_HINH.has(a);
  }
  return PAIR_HINH.some(pair => pair.includes(a) && pair.includes(b));
}

export function checkTamHinh(...branches) {
  return TAM_HINH.some(group => group.every(branch => branches.includes(branch)));
}

export function findTamHinhGroups(branches = []) {
  return TAM_HINH.filter((group) => group.every((branch) => branches.includes(branch)));
}

export function checkTuHai(a, b) {
  if (a === b) return false;
  return TU_HAI.some((pair) => isPairMatch(pair, a, b));
}

export function checkTuPha(a, b) {
  if (a === b) return false;
  return TU_PHA.some((pair) => isPairMatch(pair, a, b));
}
